export default __webpack_public_path__ + "static/media/chipsProccesedFoods.a2ce1d22.gif";